import { createFileRoute } from '@tanstack/react-router';
import { ConsultantPage } from '@/pages/consultant/consultant-page.tsx';

export const Route = createFileRoute('/_auth/berater/')({
  component: RouteComponent,
  staticData: { title: 'Berater' },
});

function RouteComponent() {
  return <ConsultantPage />;
}
